import React from 'react';

import { Box } from '@vk-hr-tek/ui/Box';
import { Icon } from '@vk-hr-tek/ui/Icon';
import { Tooltip } from '@vk-hr-tek/ui/Tooltip';
import { Typography } from '@vk-hr-tek/ui/Typography';

import { DateExplanationBadgeModule } from '../../types';

interface DateExplanationBadgeProps {
  bgWhite?: boolean;
  label?: string;
  tooltip?: string;
  module?: DateExplanationBadgeModule;
}

const MODULE_MAPPER = {
  news: 'новости',
  communityPosts: 'поста',
};

export const DateExplanationBadge = ({
  bgWhite = false,
  label = 'Дата в прошлом',
  tooltip,
  module = 'news',
}: DateExplanationBadgeProps) => {
  const defaultTooltip = `Дата завершения опроса выбрана в прошлом. После публикации ${MODULE_MAPPER[module]} опрос будет завершен`;

  return (
    <Tooltip placement="bottom" title={tooltip ?? defaultTooltip}>
      <Box
        py="4"
        px="8"
        gap="4"
        radius="s"
        display="flex"
        cursor="pointer"
        alignItems="center"
        justifyContent="space-between"
        bgcolor={bgWhite ? 'bg.light.primary' : 'accent.bg.warning'}
      >
        <Icon
          name="error_circle_outline"
          size="16"
          color="accent.text.warning"
        />

        <Typography variant="body3" color="accent.text.warning">
          {label}
        </Typography>
      </Box>
    </Tooltip>
  );
};
